module.exports = __webpack_public_path__ + "img/renew_card3.4988de91.png";